/**
 * API Module Index
 * Centralized exports for all API-related functionality
 */

// Export API client
export { default as ApiClient } from './client';

// Export API endpoints
export { API_ENDPOINTS, API_BASE_URL, buildApiUrl, getEndpoint } from './endpoints';

// Export API documentation
export { API_SCHEMAS, API_RESPONSES } from './documentation';

// Export Swagger documentation (if available)
export { default as swaggerDoc } from './swagger.json';
